<template>
  <div class="sider_8">
    <div class="title_top">
      <em>{{ cKeyWord }}的智能推荐</em>
    </div>
    <div class="under_top">
      <div
        class="checkWords"
        v-if="cRecommendWords != '' && cRecommendWords != null"
      >
        <div class="title">相关检索词：</div>
        <span
          class="aCheckWord"
          v-for="(item, index) in cRecommendWords"
          :key="index"
          @click="searchHot(item)"
          :title="item"
        >
          {{ item }}
        </span>
      </div>
      <div class="clear"></div>
      <div
        class="department"
        v-for="(item, index) in cRecommendList"
        :key="index"
      >
        <div class="title">{{ item.name }}</div>
        <ul>
          <li v-for="(Mitem, Mindex) in item.list" :key="Mindex">
            <i></i>
            <a :href="Mitem.docpuburl" v-html="Mitem.title" target="_blank"></a>
            <!-- <a :href="y[0]"
            >{{ y[1] }}<span>({{ y[2] }})</span></a
          > -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-recommend",
  components: {},
  props: {
    cTagName: {
      default: "内蒙古的智能推荐",
    },
    cKeyWord: {
      default: "",
    },
    cRecommendList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cRecommendWords: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    searchHot(item) {
      this.$emit("func", item);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.sider_8 {
  // width: 323px;
  width:100%;
  border-radius: 15px;
  margin-bottom: 40px;
  border-bottom: 1px solid #e6e6e6;
  .title_top {
    // width: 303px;
    // width:345px;
    width: 100%;
    box-sizing: border-box;
    // height: 92px;
    height:104px;
    font-size: 18px;
    font-weight: bold;
    line-height: 82px;
    padding-left: 20px;
    color: #ffffff;
    background-image: url("../../assets/img/recommend_title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .under_top {
    // width: 321px;
    width:100%;
    border-right: 1px solid #e6e6e6;
    border-left: 1px solid #e6e6e6;
  }
  .title {
    width: 323px;
    // height: 92px;
    font-size: 15px;
    padding-bottom: 15px;
    // font-weight: bold;
    color: #4274a4;
  }
  .checkWords {
    width: 100%;
    // margin-left: 20px;
    // margin-top: 15px;
    margin-bottom: 15px;
    padding-left: 20px;
    box-sizing: border-box;

    .title {
      width: 100%;
      font-size: 15px;
    }

    .aCheckWord {
      display: inline-block;
      // width: 80px;
      // height: 25px;
      font-size: 15px;
      margin-right: 8px;
      margin-bottom: 8px;
      border: 1px solid #e6e6e6;
      color: #666666;
      text-align: center;
      line-height: 25px;
      cursor: pointer;
      padding: 2px 5px 2px 5px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
  }
  .department {
    // width: 330px;
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
    // margin-left: 20px;
    margin-bottom: 10px;
    // margin-top: 15px;
    .title {
      width: 100%;
      font-size: 15px;
    }
    ul {
      margin: 0;
      padding: 0;
      overflow: hidden;

      li {
        display: inline-block;
        // width: 280px;
        width:95%;
        height: 24px;
        font-size: 14px;
        line-height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
          display: inline-block;
          width: 15px;
          height: 15px;
          background-image: url(../../assets/img/pointer.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          top: 10%;
          position: relative;
        }
        a {
          color: #333;
        }
      }
      li:hover {
        a {
          color: rgb(1, 82, 147);
          font-weight: bold;
        }
      }
    }
  }
}
</style>